import { useQuery } from '@apollo/client/react'
import { useMemo } from 'react'

import { gql } from '../../__generated__/graphql/catalog/gql'
import { QueryStatus } from '../../lib/hooks/types'

import type { EmbroideryProviderEmbroideryOptionFieldsFragment } from '../../__generated__/graphql/catalog/graphql'

gql(`
  fragment EmbroideryProviderEmbroideryOptionFields on EmbroideryOptions {
    id
    fonts {
      id
      key
      scale
      displayName
      designFile
    }
    colors {
      id
      key
      displayName
      hexCode
      designFile
    }
    iconGroups {
      id
      displayName
      disabledInitialsText
      icons {
        id
        key
        designFile
        scale
        image {
          id
          label
          altText
          aspectRatio
          src
        }
      }
    }
  }
`)

const getEmbroideryDesignsQuery = gql(`
  query GetEmbroideryDesigns {
    embroideryOptions {
      ...EmbroideryProviderEmbroideryOptionFields
    }
  }  
`)

export type EmbroideryIconGroup =
  EmbroideryProviderEmbroideryOptionFieldsFragment['iconGroups'][number]

export type EmbroideryIcon =
  EmbroideryProviderEmbroideryOptionFieldsFragment['iconGroups'][number]['icons'][number]

export type EmbroideryIconAsset = EmbroideryIcon['image']

export type EmbroideryColor = EmbroideryProviderEmbroideryOptionFieldsFragment['colors'][number]

export type EmbroideryFont = EmbroideryProviderEmbroideryOptionFieldsFragment['fonts'][number]

export const useEmbroideryDesignsQuery = () => {
  const response = useQuery(getEmbroideryDesignsQuery)
  return useMemo(() => {
    const status: QueryStatus = response.loading
      ? 'pending'
      : response.error
      ? 'rejected'
      : 'resolved'
    return {
      data: response.data,
      previousData: response.previousData,
      status,
    }
  }, [response.data, response.error, response.loading, response.previousData])
}
